module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "inbox"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Inbox")]), _vm._v(" "), _c('inboxFilter'), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.showModal) ? _c('retype-dialog', {
    attrs: {
      "infobit": _vm.selectedInfobit
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: (_vm.infobits),
      expression: "infobits"
    }],
    attrs: {
      "bag": "infobits"
    }
  }, _vm._l((_vm.infobits), function(infobit) {
    return _c('li', {
      key: infobit.id,
      staticClass: "inbox-item"
    }, [_c('infobit', {
      attrs: {
        "infobit": infobit
      }
    }, [_c('button', {
      staticClass: "fa fa-copy",
      attrs: {
        "title": "Copy"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.copyToClipboard(infobit)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "fa fa-exchange",
      attrs: {
        "title": "Retype",
        "disabled": !_vm.loggedInUser
      },
      on: {
        "click": function($event) {
          return _vm.showRetypeDialog(infobit)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "fa fa-remove",
      attrs: {
        "title": "Remove from inbox",
        "disabled": !_vm.loggedInUser
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(infobit.id)
        }
      }
    })])], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-074a4f01!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inbox.vue
// module id = 131
// module chunks = 0